import type { SVGProps } from 'react'
const LineWheelchair = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		fill="none"
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M7.25 4.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0M8.5 2a2.75 2.75 0 0 0-.626 5.428l.35 1.697a6.5 6.5 0 1 0 7.463 8.375h-1.603a5.002 5.002 0 0 1-9.584-2 5 5 0 0 1 4.026-4.905l.66 3.21A2.75 2.75 0 0 0 11.88 16h4.984l2.698 3.777 2.104-1.403-.832-1.248-.896.597-1.928-2.7a1.25 1.25 0 0 0-1.017-.523H11.88a1.25 1.25 0 0 1-1.224-.998l-.618-3.002h.401l1.634 1.634c.235.234.553.366.884.366H15.5V11h-2.44l-1.633-1.634A1.25 1.25 0 0 0 10.543 9h-.814L9.39 7.353A2.751 2.751 0 0 0 8.5 2"
			clipRule="evenodd"
		/>
	</svg>
)
export { LineWheelchair }
